import {
  AfterViewInit,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../../@core/data/users";
import { UserService } from "../../../@core/services/user.service";
import { convertTimestamp } from "../../../@core/utils/convertTimestamps.service";
import { Receipt } from "../../../models/receipt.model";
import Shop from "../../../models/shop.model";

@Component({
  selector: "ngx-layout-receipt-a4-ppd",
  templateUrl: "layout-receipt-a4-ppd.component.html",
  styleUrls: ["layout-receipt-a4-ppd.component.scss"],
})
export class LayoutReceiptA4PPDComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() receipt?: Receipt;
  @Input() shop?: Shop;
  @Input() isRefLanguage?: boolean = false;
  @Input() showDept?: boolean = true;
  @Input() totalAmountText?: string = "";
  @Input() totalAmountDebitText?: string = "";

  loading = false;
  printing = false;
  displayName = "";
  currentDate: Date = new Date();

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.shopId = user.shopId ? user.shopId : user.uid;
          this.displayName = user.displayName ? user.displayName : user.email;
        } else {
          this.uid = "anonymous";
          this.shopId = "anonymous";
          this.displayName = "";
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => {});
  }

  print() {
    this.printing = true;
  }
}
